import { saveToStorage, getFromStorage } from "../../../../used-vue/api/Storage";
import getActualKeyFromKey from "../../../../used-vue/api/finance/GetActualKeyFromKey";
import getFinanceNameFromKey from "../../../../used-vue/api/finance/GetFinanceNameFromKey";
import { getDefaultTerm, getDefaultMileage } from "../../../../used-vue/api/finance/GetDefaults";
import dispatchFinanceModifiedEvent from "../../../../core/modules/dispatch-finance-modified-event";

export default class {
    constructor(vehicle) {
        this.vehicle = vehicle;
        // The actual key we send CW might be different than what we call it on our end. e.g. HP might be change to be PREPROD_HP, but we don't want to change every single instance on the website to PREPROD_HP
        // Instead we just update the keys in /config/codeweavers-keys.php, and then run php artisan json:build. This will generate/update resources/assets/js/modules/json/financeKeys.js, which we can use in JS to convert to the correct key name
        // In the example above, this.pseudoKey is HP, and this.key would end up as PREPROD_HP
        this.pseudoKey = '';
        this.key = '';
        this.name = '';
        this.shortName = '';
        this.longName = '';
        this.order = 999;
        this.defaultTerm = 42;
        this.defaultMileage = 10000;
        this.defaultDeposit = window.defaultDeposit || 2315;
        this.alwaysShow = false;

        this.fallbackDeposit = {
            min: 0,
            max: 30000,
        };
        this.deposit = {};
        this.fixedDeposit = false;
        this.depositSlider = false;
        this.depositInput = false;
        this.depositVariableText = false;
        this.depositFixedText = false;

        this.fallbackTerms = [
            24,
            36,
            48,
        ];
        this.terms = [];
        this.termSlider = false;
        this.termSelect = false;
        this.termVariableText = false;
        this.termFixedText = false;

        this.fallbackMileages = [
            6000,
            7000,
            8000,
            9000,
            10000,
            11000,
            12000,
            13000,
            14000,
            15000,
            16000,
            17000,
            18000,
            19000,
            20000,
            25000,
            30000,
        ];
        this.mileages = [];
        this.fixedMileage = false;
        this.isTelematics = false;
        this.requiresAge = false;
        this.requiresPostcode = false;
    }

    getActualKeyFromKey(key) {
        return getActualKeyFromKey(key);
    }

    getFinanceNameFromKey(vehicle, key) {
        return getFinanceNameFromKey(vehicle, key);
    }

    getShortFinanceNameFromKey(vehicle, key) {
        return getFinanceNameFromKey(vehicle, key, true);
    }

    getDefaultTerm() {
        return getDefaultTerm();
    }

    getDefaultMileage() {
        return getDefaultMileage();
    }

    getAllowedTerms() {
        return this.fallbackTerms;
    }

    getAllowedDeposit() {
        return this.fallbackDeposit;
    }

    getAllowedMileages() {
        return this.fallbackMileages;
    }

    buildFinanceAdjustmentNotifications(codeweaversResponse, quote) {
        if (typeof codeweaversResponse.financeRequest.Parameters == 'undefined') {
            return '';
        }

        let errorMessage = '';

        const originalMileage = codeweaversResponse.financeRequest.Parameters.AnnualMileage || 0;
        const returnedMileage = quote.AnnualMileage || 0;

        if (parseInt(returnedMileage) > 0 && parseInt(returnedMileage) != parseInt(originalMileage)) {
            errorMessage += '<span class="glyphicons glyphicons-exclamation-sign pull-left"></span>The mileage you chose ('+number_format(originalMileage,0)+' miles per annum) was unavailable, the nearest alternative of '+number_format(quote.AnnualMileage,0)+' has been used instead<br />';
        }

        const originalDeposit = codeweaversResponse.financeRequest.Parameters.Deposit || 0;
        const returnedDeposit = quote.CashDeposit || 0;

        if (parseInt(returnedDeposit) != parseInt(originalDeposit) && Math.abs(parseFloat(returnedDeposit) - parseFloat(originalDeposit)) > 3 ) {
            if (this.pseudoKey == 'HP') {
                errorMessage += '<span class="glyphicons glyphicons-exclamation-sign pull-left"></span>In order to qualify for the low rate APR, you must have customer deposit of ‘£'+number_format(returnedDeposit,2)+'’. This value is now displayed in the quote.<br />';
            } else {
                errorMessage += '<span class="glyphicons glyphicons-exclamation-sign pull-left"></span>The deposit you chose (&pound;'+number_format(originalDeposit,2)+') was unavailable, the nearest alternative of &pound;'+number_format(returnedDeposit,2)+' has been used instead<br />';
            }
        }

        const originalTerm = codeweaversResponse.financeRequest.Parameters.Term || 0;
        const returnedTerm = quote.Term || 0;

        if (parseInt(returnedTerm) != parseInt(originalTerm)) {
            errorMessage += '<span class="glyphicons glyphicons-exclamation-sign pull-left"></span>The term you chose ('+number_format(originalTerm,0)+' months) was unavailable, the nearest alternative of '+number_format(returnedTerm,0)+' months has been used instead<br />';
        }

        if (errorMessage !== '') {
            return '<p class="bg-warning">'+errorMessage+'</p>';
        }

        return '';
    }

    getTermsAndConditions(codeweaversResponse) {
        let quote = codeweaversResponse.getFinanceProductOfInterest(this);
        if (quote.error == true) {
            return false;
        }
        let html = '';
        if (this.isFinanceModified()) {
            html = 'This is your personal quote, we will retain your deposit as you move around the website. ';
        }
        if (codeweaversResponse.vehicleObject.brand == 'vauxhall') {
            return `<span class="personal-quote">^${html}This quote is valid for a maximum of 14 days from <i>${codeweaversResponse.vehicleObject.quoteValidDate} and may be withdrawn without notice</i>.&nbsp;</span>Conditional Sale. Finance subject to status. Ts&Cs apply. Applicants must be 18+. Finance by Vauxhall Finance, CF15 7YT. We act as a credit broker, not a lender. We can introduce you to a limited number of finance providers, commission may be received. <a href="/terms-and-conditions" target="_blank">Ts and Cs apply</a>`;
        }

        return `<span class="personal-quote">^${html}This quote is valid for a maximum of 14 days from <i>${codeweaversResponse.vehicleObject.quoteValidDate} and may be withdrawn without notice</i>.&nbsp;</span>Finance subject to status and age limitations. Stellantis Financial Services UK Limited RH1 1QA. <b>Stellantis &You UK Limited, trading as Stellantis &You Sales & Services, is acting as a broker not a lender and will introduce you to a limited number of lenders.</b> <a href="/terms-and-conditions" target="_blank">Ts and Cs apply</a>`;
    }

    formatTerm(term) {
        return term + ((term == 1) ? ' month' : ' months');
    }

    formatDeposit(deposit) {
        return '£' + number_format(deposit, 2)
    }

    formatMileage(mileage) {
        return number_format(mileage, 0) + ((mileage == 1) ? ' mile' : ' miles');
    }

    markFinanceAsModified() {
        saveToStorage('new_finance_modified', 'Y');
        dispatchFinanceModifiedEvent(true);
    }

    isFinanceModified() {
        if (getFromStorage('new_finance_modified') != 'Y') {
            return false;
        }
        return true;
    }

    getPrice(codeweaversResponse) {
        const quote = codeweaversResponse.getFinanceProductOfInterest(this);
        return quote.getMonthlyPayment();
    }

    getRelevantCustomerParameters(customerParameters) {
        return [
            {
                title: 'Requested Finance',
                value: this.longName
            },
            {
                title: 'Requested Term',
                value: this.formatTerm(customerParameters.getTerm(this)),
            },
            {
                title: 'Requested Deposit',
                value: this.formatDeposit(customerParameters.getDeposit(this)),
            },
            {
                title: 'Requested Annual Mileage',
                value: this.formatMileage(customerParameters.getMileage(this)),
            },
        ];
    }

    /**
     * Get the rendered quote HTML
     * @param {CodeweaversResponse} codeweaversResponse
     * @returns {String}
     */
    render(codeweaversResponse) {
        let quote = codeweaversResponse.getFinanceProductOfInterest(this);
        if (quote.error == true) {
            console.error('quote wasnt defined', quote);
            return;
        }

        let h = [];

        h.concat(this.buildFinanceAdjustmentNotifications(codeweaversResponse, quote));
        const titleValuePairs = this.getQuoteTitleValuePairs(quote);
        titleValuePairs.forEach(element => {
            h.push(`<div class="flex-row between-xs finance-table__row"><div class="flex-xs-8 finance-table__key">${element.title}</div><div class="flex-xs-4 finance-table__value">${element.value}</div></div>`);
        });

        return h.join('');
    }

    /**
     * Append the vehicle price, and any applicable grants (e.g. government grant)
     * @param {Array} outputArray
     * @param {Array} quote
     * @returns {Array}
     */
    appendVehiclePricingIncludingApplicableGrants(outputArray, quote) {
        const retailPrice = parseFloat(this.vehicle.retailPrice);
        const cashPrice = parseFloat((quote.financeProduct.Quote.CashPrice || retailPrice));
        const grant = quote.getGovernmentGrant();

        if (retailPrice !== cashPrice) {
            outputArray.push({
                title: 'Vehicle Price (OTR)',
                value: '&pound;' + number_format(retailPrice, 2)
            });

            if (grant > 0) {
                outputArray.push({
                    title: 'Government Grant',
                    value: '&pound;' + number_format(grant, 2)
                });
            }

            outputArray.push({
                title: 'Vehicle Selling Price',
                value: '&pound;' + number_format(cashPrice, 2)
            });
        } else if (grant > 0 && retailPrice == cashPrice) {
            outputArray.push({
                title: 'Vehicle Price (OTR)',
                value: '&pound;' + number_format(retailPrice + grant, 2)
            });

            outputArray.push({
                title: 'Government Grant',
                value: '&pound;' + number_format(grant, 2)
            });

            outputArray.push({
                title: 'Vehicle Selling Price',
                value: '&pound;' + number_format(cashPrice, 2)
            });
        } else {
            outputArray.push({
                title: 'Vehicle Price',
                value: '&pound;' + number_format(cashPrice, 2)
            });
        }

        return outputArray;
    }

    brandName() {
        if (this.vehicle.manufacturer == 'peugeot') {
            return 'Peugeot';
        }
        if (this.vehicle.manufacturer == 'citroen') {
            return 'Citroen';
        }
        if (this.vehicle.manufacturer == 'vauxhall') {
            return 'Vauxhall';
        }
        if (this.vehicle.manufacturer == 'ds') {
            return 'DS';
        }
        if (this.vehicle.manufacturer == 'ds automobiles') {
            return 'DS';
        }
        if (this.vehicle.manufacturer == 'fiat') {
            return 'Fiat';
        }
        if (this.vehicle.manufacturer == 'abarth') {
            return 'Abarth';
        }
        return 'Stellantis &You UK';
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/new-car-pages/modules/finance/finance-product-objects/finance-key-object.js